import './Microguide.css';
export var microguideAnimatedContentCSS = '_196hxam3-2-0-1';
export var microguideContentWrapperCSS = '_196hxam2-2-0-1';
export var microguideFooterCSS = '_196hxam4-2-0-1';
export var microguideStepContainerCSS = '_196hxam0-2-0-1';
export var microguideVisualWrapperCSS = '_196hxam1-2-0-1';
export var microguideWrapperCSS = '_196hxam5-2-0-1';
export var microguideWrapperPositionCSS = {'bottom-left':'_196hxam6-2-0-1','top-right':'_196hxam7-2-0-1','top-left':'_196hxam8-2-0-1','bottom-right':'_196hxam9-2-0-1'};